import useSWR from 'swr';
import { getDataFreshness } from '../../api';
import type { DataFreshnessResponse } from './types/database';

interface UseDataFreshnessReturn {
  data: DataFreshnessResponse | undefined;
  isLoading: boolean;
  isError: any;
  mutate: () => void;
}

/**
 * Hook to fetch data freshness status for all data types
 *
 * @returns Data freshness information, loading state, error state, and mutate function
 *
 * @example
 * const { data, isLoading } = useDataFreshness();
 *
 * // Access freshness status for different data types
 * data?.data_types.forEach(dt => {
 *   console.log(`${dt.name}: ${dt.status} - last updated ${dt.last_updated}`);
 * });
 */
export function useDataFreshness(): UseDataFreshnessReturn {
  const { data, error, mutate } = useSWR<DataFreshnessResponse>(
    '/admin/db-stats/freshness',
    getDataFreshness,
    {
      refreshInterval: 30000, // Refresh every 30 seconds
      revalidateOnMount: true,
    }
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
